import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./app/auth";
import Appointments from "./app/auth/appointments";
import Claim from "./app/auth/claim";
import IntimateClaim from "./app/auth/claim/intimate_claim";
import NonHealthClaims from "./app/auth/claim/non_health_claims";
import Dashboard from "./app/auth/dashboard";
import Enquiries from "./app/auth/enquiry";
import InnerContent from "./app/auth/inner_content";
import MyProfile from "./app/auth/my_profile";
import Notifications from "./app/auth/notifications/list";
import Policies from "./app/auth/policies";
import PolicyWallet from "./app/auth/policy_wallet";
import AddPolicyWallet from "./app/auth/policy_wallet/add";
import Reviews from "./app/auth/reviews";
import PublicRoutes from "./app/public";
import ForgotPassword from "./app/public/forgot_password";
import Login from "./app/public/login";
import NewPassword from "./app/public/new_password";
import EmailLeadForm from "./app/auth/email_lead_form/update";

const MainRoutes = () => {


    return (
        <Routes>
            <Route path="/" element={<ProtectedRoutes />}>
                <Route path="/" element={<InnerContent />}>
                    <Route path="/" element={<Navigate replace to="dashboard" />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="policies" element={<Policies />} />
                    <Route path="appointments" element={<Appointments />} />

                    <Route path="claim">
                        <Route index element={<Claim />} />
                        <Route path="intimate-claim" element={<IntimateClaim />} />
                        <Route path="non-health-claims" element={<NonHealthClaims />} />
                    </Route>
                    <Route path="policy-wallet">
                        <Route index element={<PolicyWallet />} />
                        <Route path="add-policy-wallet" element={<AddPolicyWallet />} />
                    </Route>
                    <Route path="enquiry" element={<Enquiries />} />
                    <Route path="notifications" element={<Notifications />} />
                    <Route path="my-profile" element={<MyProfile />} />
                    <Route path="reviews" element={<Reviews />} />
                    <Route path="verification" element={<EmailLeadForm />} />
                </Route>

            </Route>
            <Route path="/" element={<PublicRoutes />}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token/:emailid" element={<NewPassword />} />
            </Route>
        </Routes>
    )
}

export default MainRoutes;